export default __webpack_public_path__ + "static/image 57-667cba3f5cb6728de7e88056fbf98b77.png";